import React from "react"
import styled from "styled-components"
import { em } from "polished"
import humanizeString from "humanize-string"

import { ReactComponent as SvgChevronDown } from "../../assets/icons/chevron-down.svg"

const FIELDS = [
  `facts`,
  `directions`,
  `regulations`,
  `communications`,
  `parking`,
  `surface`,
  `hills`,
  `vegetation`,
]

const Infoblocks = ({ translations, data, Title, Styled, className }) => {
  if (!data) return null

  const blocks = []

  FIELDS.forEach((f) => {
    if (data[f])
      blocks.push({
        id: f,
        title: translations.global[f] || humanizeString(f),
        content: data[f],
      })
  })

  if (!blocks.length) return null

  return (
    <Container className={className}>
      {blocks.map((block) => (
        <Details key={block.id}>
          <Summary>
            <Title as="h2">{block.title}</Title>

            <SvgChevronDown aria-hidden="true" />
          </Summary>

          <Content>
            <Styled dangerouslySetInnerHTML={{ __html: block.content }} />
          </Content>
        </Details>
      ))}
    </Container>
  )
}

export default Infoblocks

const Container = styled.div``

const Details = styled.details`
  padding: 0 ${em(20)};
  background-color: ${({ theme }) =>
    theme.components?.infoblocks?.backgroundColor};
  border: 1px solid
    ${({ theme }) => theme.components?.infoblocks?.borderColor || `#ddd`};
  border-radius: ${({ theme }) => theme.components?.infoblocks?.borderRadius};

  &[open] {
    background-color: ${({ theme }) =>
      theme.components?.infoblocks?.openBackgroundColor};
  }

  & + & {
    margin-top: ${em(16)};
  }
`

const Summary = styled.summary`
  width: 100%;
  padding: ${em(16)} 0;
  display: flex;
  gap: ${em(20)};
  justify-content: space-between;
  align-items: center;
  outline-offset: ${em(6)};

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.5;
  }

  svg {
    width: ${em(14)};
    height: ${em(14)};
    flex-shrink: 0;

    ${Details}[open] & {
      transform: rotate(180deg);
    }
  }
`

const Content = styled.div`
  margin-bottom: ${em(20)};
  padding-top: ${em(20)};

  border-top: 1px solid
    ${({ theme }) => theme.components?.infoblocks?.borderColor || `#ddd`};
`
